import React from 'react';
import AtlasV2PromotionsByCategoryTopEntityChart from 'src/components/AtlasV2Components/AtlasV2PromotionsComponents/AtlasV2PromotionsByCategoryTopEntityChart';
import AtlasV2PromotionsByDealTypeTopEntityChart from 'src/components/AtlasV2Components/AtlasV2PromotionsComponents/AtlasV2PromotionsByDealTypeTopEntityChart';
import AtlasV2PromotionsProductTable from 'src/components/AtlasV2Components/AtlasV2PromotionsComponents/AtlasV2PromotionsProductTable';
import { AtlasV2PromotionsTopSection } from 'src/components/AtlasV2Components/AtlasV2PromotionsComponents/AtlasV2PromotionsTopSection';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Price Promotion Page layout - Tab name: prices subtab name: promotion
 */
export const AtlasV2PricePromotionPageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* Top donut chart and the mini spline chart */}
        <AtlasV2PromotionsTopSection />
        {/* Double dropdown by Category / SubCategory / Brand / Manufact */}
        <AtlasV2PromotionsByCategoryTopEntityChart />
        {/* Single Dropdown by Deal Type */}
        <AtlasV2PromotionsByDealTypeTopEntityChart />
        {/* Promotion table */}
        <AtlasV2PromotionsProductTable />
      </Flex>
    </BasePageContainer>
  );
};
